export interface PermissaoInterface {
  id_perfil?: number
  nome_perfil: string
  situacao: number
  master: number
}

export interface MenuPermissao {
  cadastro: boolean;
  paineldecontrole: boolean;
  tickets: boolean;
}

export const PERFIL_PAINEL_TV = "painel_tv";
export const FUNCAO_PAINEL_TV = "PAINEL_TV";

export const PERMISSOES_POR_PERFIL: Record<string, MenuPermissao> = {
  agente: {
    cadastro: true,
    paineldecontrole: true,
    tickets: true
  },
  usuario: {
    cadastro: false,
    paineldecontrole: true,
    tickets: true
  },
  painel_tv: {
    cadastro: false,
    paineldecontrole: true,
    tickets: false
  }
};
